export function safeOAuthAuthorizationURL(value: string): string {
  const parsed = new URL(value);
  if (parsed.protocol !== "https:" || parsed.username || parsed.password || parsed.hash) throw new Error("Unsafe OAuth authorization URL");
  return parsed.toString();
}

export function oauthFragment(fragment: string): { flowToken: string; intent: string } {
  const params = new URLSearchParams(fragment.replace(/^#/, ""));
  return { flowToken: params.get("flow_token") ?? "", intent: params.get("intent") ?? "login" };
}
